// import logo from './logo.svg';
import './App.css';
import {
  Header,
  SecHeader,
  DriveComp,
} from '../src/components/header'
import SwipeToSlide from '../src/components/slider'
import LazyLoad from '../src/components/slider2'
import SwipeToSlid from '../src/components/slider3'
import DayDream from '../src/components/dayDreams'
import DriveComp2 from '../src/components/meethost'
import Theme from '../src/components/theme'
import Theme2 from '../src/components/theme2'
import AutoPlay from '../src/components/slider4'
import Slider5 from '../src/components/slider5'
import {FreqQuest,FreqQuest2}from '../src/components/freqQuest';
import Footer from '../src/components/footer';



function App() {
  return (
    <div className="App">
      {/* <Apps  /> */}
       <header className="header">
       <Header />
       </header>

       <div className='Secheader'>
        <SecHeader />
       </div>
       <div className="Drive-div">
        <DriveComp />
       </div>
       <div className="slider1">
        <SwipeToSlide />
       </div>
       <div className="slider2">
        <LazyLoad />
       </div>
       <div className="slider3">
        <SwipeToSlid />
       </div>
       <div className="dayDreams">
        <DayDream />
       </div>
       <div className="theme">
       <Theme />
       </div>
       <div className="slider4">
        <AutoPlay />
       </div>
       <div className="Drive-div2">
        <DriveComp2 />
       </div>
       <div className="slider5">
        <Slider5 />
       </div>
       <div className="theme2">
       <Theme2 />
       </div>
       <div className="fre_quest">
       <FreqQuest />
       </div>
       <div className="Question_div">
       <FreqQuest2 />
       </div>
       <div className="foot">
       <Footer />
       </div>
    </div>
  );
}
export default App;
